import { Button, Icon, Dropdown, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useOnboardingStore } from '@hero/store/hooks';

import * as S from './style';

function OnboardingCard({
  styles,
  position = 'left-top',
  isInfoActive = false,
  isCardShown = false,
  setIsCardShown,
  title,
  content,
  description,
  cardOffset = [-8, 8],
  onTourButtonClick,
  featureType,
  allowedAutoPlacements = ['right', 'left']
}) {
  const { t } = useTranslation();
  const { updateTourProgress } = useOnboardingStore();

  const { wrapper } = styles || {};

  const toggleMenu = setIsMenuOpen => {
    if (setIsCardShown) {
      setIsCardShown(!isCardShown);
    } else {
      setIsMenuOpen(prev => !prev);
    }
  };

  return isInfoActive ? (
    <S.OnboardingCard style={wrapper}>
      <Dropdown
        isMenuOpenDefault={isCardShown}
        popperOptions={{
          placement: position,
          modifiers: [
            {
              name: 'offset',
              enabled: true,
              options: {
                offset: cardOffset
              }
            },
            {
              name: 'flip',
              enabled: true,
              options: {
                rootBoundary: 'viewport',
                allowedAutoPlacements,
                altBoundary: true
              }
            }
          ]
        }}
        referenceComponent={({ setIsMenuOpen }) => (
          <S.YellowPointer
            color="default"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              toggleMenu(setIsMenuOpen);
            }}
          >
            <Icon name="onboarding-tour-pointer" color="var(--color-warning-default)" />
            <S.CircleAnimation />
          </S.YellowPointer>
        )}
      >
        {() => (
          <S.CardWrapper>
            <S.ContentWrapper>
              <Typography variant="body2" color="primary" fontWeight="700">
                {title}
              </Typography>
              <Typography variant="body3" style={{ marginTop: 8 }}>
                {description}
              </Typography>
              <S.Content>{content}</S.Content>
            </S.ContentWrapper>
            <S.Footer>
              <Button
                variant="text"
                onClick={async e => {
                  e.stopPropagation();
                  setIsCardShown(!isCardShown);

                  updateTourProgress({
                    featureType,
                    infoCardsActive: false
                  });
                }}
                color="secondary"
              >
                {t('skipTour')}
              </Button>
              <Button
                onClick={e => {
                  e.stopPropagation();
                  setIsCardShown(!isCardShown);
                  if (onTourButtonClick) onTourButtonClick();
                }}
              >
                {t('next')}
              </Button>
            </S.Footer>
          </S.CardWrapper>
        )}
      </Dropdown>
    </S.OnboardingCard>
  ) : null;
}

export { OnboardingCard };
